import React from "react";
import Select from "../../parts/inputs/select";
import ToolTip from "../../parts/tooltip";

const generateSortUrl = (field, query) => {
  const sortBy = field;
  const sortType = query.sortType && query.sortType === "asc" ? "desc" : "asc";
  return `/admin/reports?reports=coaches&sortBy=${sortBy}&sortType=${sortType}`;
};

function View(props) {
  const {
    coaches,
    totalAthletes,
    totalAthletesActive,
    totalAthletesInactive,
    momentTZ,
    query,
  } = props;

  return (
    <div>
      <form action="/admin/reports" method="GET">
        <div className="search search-coaches">
          <div className="flex items-center gap-4">
            <div className="column">
              <input type="hidden" name="reports" defaultValue="coaches" />
              <input
                type="search"
                className="text-input"
                name="name"
                placeholder="Name"
                defaultValue={query.name}
              />
            </div>
            <div className="column">
              <input
                type="search"
                className="text-input"
                name="email"
                placeholder="E-mail"
                defaultValue={query.email}
              />
            </div>
            <div className="column">
              <Select
                name="trialStatus"
                className="select-input"
                value={query.trialStatus || "any"}
                options={[
                  { text: "Trial Status", value: "any" },
                  { text: "Free Trial", value: "Free Trial" },
                  { text: "Expired Free Trial", value: "Expired Free Trial" },
                  { text: "Converted", value: "Converted" },
                  { text: "Cancelled", value: "Cancelled" },
                  { text: "No information", value: "No information" },
                ]}
              ></Select>
            </div>
            <div className="column">
              <button
                className="button-input"
                type="submit"
                data-button-type="primary"
              >
                Search
              </button>
            </div>
            <div className="column">
              <a
                className="button"
                target="_blank"
                href="/actions/refresh?reports=coaches&csv=true"
                data-button-type="outline"
                role="button"
              >
                Export to csv
              </a>
            </div>
          </div>
        </div>
      </form>

      <div className="reports">
        <div className="labels">
          <div className="name">
            <a href={generateSortUrl("name", query)}>Coach</a>
          </div>
          <div className="trial">
            <a href={generateSortUrl("active", query)}>
              Active ({totalAthletesActive})
            </a>
          </div>
          <div className="paid">
            <a href={generateSortUrl("inactive", query)}>
              Inactive ({totalAthletesInactive})
            </a>
          </div>
          <div className="total">
            <a href={generateSortUrl("totalAthletes", query)}>
              Total ({totalAthletes})
            </a>
          </div>
          <div className="trial-status">
            <a href={generateSortUrl("trialStatus", query)}>Trial Status</a>
          </div>
          <div className="plan">
            <a href={generateSortUrl("stripePlan", query)}>Stripe Plan</a>
          </div>
          <div className="days-left">
            <ToolTip id="daysLeft" body="Days left Free Trial">
              <a href={generateSortUrl("daysLeft", query)}>Days left FT</a>
            </ToolTip>
          </div>
          <div className="days-since">
            <ToolTip id="daysSince" body="Days since Free Trial ended">
              <a href={generateSortUrl("daysSince", query)}>
                Days since FT ended
              </a>
            </ToolTip>
          </div>
          <div className="last-logged">
            <a href={generateSortUrl("loggedIn", query)}>Last Logged In</a>
          </div>
        </div>

        {coaches &&
          coaches.map((coach) => {
            return (
              <div className="report collapsible" key={coach._id}>
                <input
                  type="checkbox"
                  id={`coach-toggle-${coach._id}`}
                  defaultChecked={false}
                />
                <div className="head">
                  <label
                    className="expand-toggle icon-green"
                    htmlFor={`coach-toggle-${coach._id}`}
                  />
                  <div className="name">
                    {coach.name}
                    <br />
                    <ToolTip id={`${coach.email}`} body={`${coach.email}`}>
                      <span className="email">({`${coach.email}`})</span>
                    </ToolTip>
                  </div>
                  <div className="trial">{coach.active}</div>
                  <div className="paid">{coach.inactive}</div>
                  <div className="total">{coach.totalAthletes}</div>
                  <div className="trial-status">{coach.trialStatus}</div>
                  <div className="plan">{coach.stripePlan}</div>
                  <div className="days-left">
                    {coach.daysLeft ? coach.daysLeft : "N/A"}
                  </div>
                  <div className="days-since">
                    {coach.daysSince ? coach.daysSince : "N/A"}
                  </div>
                  <div className="last-logged">
                    {momentTZ(coach.loggedIn).format("ll")}
                  </div>
                </div>
                <div className="details">
                  <div className="user-details">
                    <div>
                      <b>Permissions: </b>
                      {coach.permissions.join(", ")}
                    </div>
                    <div>
                      <b>Member since: </b>
                      {momentTZ(coach.registered).format("MMMM, YYYY")}
                    </div>
                  </div>
                  {!coach.athletes ||
                    (coach.athletes.length === 0 && <span>No athletes</span>)}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default View;
